import Breadcrumbs from 'components/Breadcrumbs';
import { List } from 'immutable';
import React from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { FileBrowser, FileBrowserMessage } from './FileBrowser';

interface Props extends WithAppStoreProps {
  providerType: string;
  message?: FileBrowserMessage;
  onRetryLoad?: () => void;
}

const RootMessageFileBrowser: React.FC<Props> = ({
  providerType,
  message,
  onRetryLoad,
}: Props) => {
  return (
    <>
      <div className="my2">
        <Breadcrumbs
          provider={{
            type: providerType,
            onClick: onRetryLoad || (() => {}),
          }}
        />
      </div>
      <FileBrowser items={List()} areAllSelected={false} message={message} />
    </>
  );
};

export default withAppStore<Props>(RootMessageFileBrowser);
